import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import './NavBar.scss';
import { RiArrowGoBackLine } from "react-icons/ri";

const NavBar = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const handleNavigation = (event, path) => {
    event.preventDefault();
    navigate(path);
  };

  // A helper function to determine if a link is active based on the current path
  const isActive = (path) => {
    return location.pathname === path;
  };

  return (
    <div className="nav-bar">
      <div className="nav-start">
      <RiArrowGoBackLine className="nav-icon" />
        <a href="#" onClick={(e) => handleNavigation(e, '/')} 
           className={isActive('/') ? 'active' : ''}>front page</a>
      </div>
      <div className="nav-end">
        <a href="#" onClick={(e) => handleNavigation(e, '/CopyMain')} 
           className={isActive('/CopyMain') ? 'active' : ''}>Account</a>
        <a href="#" onClick={(e) => handleNavigation(e, '/Sommet')} 
           className={isActive('/Sommet') ? 'active' : ''}>set up</a>
      </div>
    </div>
  );
};

export default NavBar;
